module.exports = __webpack_public_path__ + "static/media/working.c611f9d2.png";